export default __webpack_public_path__ + "static/crab_station_back_menu-772a0a897ca8aabf0932555ca2383d3f.pdf";